import createEntityBundle from '~/src/Lib/createEntityBundle'
import { WasteReason as schema } from '~/src/Store/Schemas'

const name = 'wasteReasons'

export default createEntityBundle({
  name,
  apiConfig: {
    schema,
  },
})
